import {
    FBA_cascadeNotifications,
    FBA_displayCountryFlags,
    FBA_emailAttachment,
    FBA_enableKatmaiReads,
    FBA_followUps,
    FBA_integrationFacebook,
    FBA_integrationMsTeams,
    FBA_integrationSlack,
    FBA_integrationTwitter,
    FBA_integrations,
    FBA_internalConference,
    FBA_lockboxShared,
    FBA_mfa,
    FBA_opt_in,
    FBA_recipientSchedule,
    FBA_scenarioLibrary,
    FBA_smsSegmentCount,
    FBA_riskintelligenceFF,
    FBA_nextGenSendingEngine,
    FBA_assetDatastore,
    FBA_mapViewOff,
    createDoNotContact,
    deleteDoNotContact,
    editDoNotContact,
    viewDoNotContact,
    FBA_enableExternalLinks,
    viewExternalLinks,
    FBA_opv3Services,
    FBA_riskIntelligenceDivisionSync,
    FBA_boundaryManagement,
    viewDivisionBoundary,
    editDivisionBoundary,
    FBA_billingUsage,
    orgAdmin,
    billingUsage,
    peopleOverTime,
    FBA_peopleOverTime,
    FBA_ipaws,
    initiateIpaws,
    viewPreDefinedLocations,
    viewIntegration
} from 'common/constants/permissions';
import { checkResourceAccessByDivisions } from '../utils';
import { orgIDEnum } from '../../../common/constants/appNames';
import jwtService from '@services/jwt.service';

const canDisplayCountryFlags = permissions => !!permissions[FBA_displayCountryFlags];
const canManageRecipientSchedule = permissions => !!permissions[FBA_recipientSchedule];
const canManageInternalConferenceResponse = permissions => !!permissions[FBA_internalConference];
const canManageTwitter = permissions => !!permissions[FBA_integrationTwitter];
const canManageFollowUps = permissions => !!permissions[FBA_followUps];
const canManageSmsOptIn = permissions => !!permissions[FBA_opt_in];
const canManageCascadeNotifications = permissions => !!permissions[FBA_cascadeNotifications];
const canManageEmailAttachment = permissions => !!permissions[FBA_emailAttachment];
const canManageSMSSegments = permissions => !!permissions[FBA_smsSegmentCount];
const canManageScenarioLibrary = permissions => !!permissions[FBA_scenarioLibrary];
const canViewMFA = permissions => !!permissions[FBA_mfa];
const canViewAdvancedContactsFilter = permissions => !!permissions[FBA_enableKatmaiReads];
const canViewAdvancedGroupFilter = permissions => !!permissions[FBA_enableKatmaiReads];
const canManageIntegrations = permissions => !!permissions[FBA_integrations];
const canManageFacebook = permissions => !!permissions[FBA_integrationFacebook];
const canManageSlack = permissions => !!permissions[FBA_integrationSlack];
const canManageMSTeams = permissions => !!permissions[FBA_integrationMsTeams];
const canManageLockBox = permissions => !!permissions[FBA_lockboxShared];
const canManageRiskIntelligence = permissions => !!permissions[FBA_riskintelligenceFF];
const canCreateDoNotContact = permissions => !!permissions[createDoNotContact];
const canViewDoNotContact = permissions => !!permissions[viewDoNotContact];
const canEditDoNotContact = permissions => !!permissions[editDoNotContact];
const canDeleteDoNotContact = permissions => !!permissions[deleteDoNotContact];
const usesNextGenSendingEngine = permissions => !!permissions[FBA_nextGenSendingEngine];
const canAccessAssetUI = permissions => !!permissions[FBA_assetDatastore];
const canViewAssetDataStore = permissions => !!permissions[FBA_assetDatastore];
const canViewMapOff = (permissions) => !!permissions[FBA_mapViewOff];
const canManageAssetDataStore = permissions => permissions[FBA_assetDatastore];



const canManageExternalLinks = permissions => !!permissions[FBA_enableExternalLinks];
const canViewExternalLinks = permissions => !!permissions[viewExternalLinks];
const canViewOpV3 = permissions => !!permissions[FBA_opv3Services];
const canManageRiskIntelligenceDivisionSync = permissions => !!permissions[FBA_riskIntelligenceDivisionSync];
const canViewDivisionBoundaries = permissions =>
    !!permissions[FBA_boundaryManagement] &&
    (!!permissions[viewDivisionBoundary] || !!permissions[editDivisionBoundary]);
const canViewBillingUsage = permissions =>
        !!permissions[FBA_billingUsage] && (!!permissions[orgAdmin] || !!permissions[billingUsage]);
const canViewPeopleOverTime = permissions =>
        !!permissions[FBA_peopleOverTime] && (!!permissions[orgAdmin] || !!permissions[peopleOverTime]);
const canManageIpaws = permissions => !!permissions[FBA_ipaws];
const canInitiateIpaws = (permissions, params) => {
    if (!params) {
        return !!permissions[initiateIpaws];
    }
    return checkResourceAccessByDivisions(initiateIpaws, params);
};
const canViewPredefinedLocations = permissions => permissions[viewPreDefinedLocations];
const canViewIntegration = permissions => !!permissions[viewIntegration];



const canViewOPV3ADS = permissions => canViewOpV3(permissions) && canManageAssetDataStore(permissions);
const isCRCOrg = permissions =>
        jwtService.getOrgTypeId() === orgIDEnum.CODERED && canViewAssetDataStore(permissions) && usesNextGenSendingEngine(permissions);


    

export default {
    canDisplayCountryFlags,
    canManageRecipientSchedule,
    canManageInternalConferenceResponse,
    canManageFollowUps,
    canManageSmsOptIn,
    canManageCascadeNotifications,
    canManageEmailAttachment,
    canManageSMSSegments,
    canManageTwitter,
    canManageScenarioLibrary,
    canViewMFA,
    canViewAdvancedContactsFilter,
    canViewAdvancedGroupFilter,
    canManageIntegrations,
    canManageFacebook,
    canManageSlack,
    canManageMSTeams,
    canManageLockBox,
    canCreateDoNotContact,
    canEditDoNotContact,
    canViewDoNotContact,
    canDeleteDoNotContact,
    canManageRiskIntelligence,
    usesNextGenSendingEngine,
    canAccessAssetUI,
    canViewAssetDataStore,
    canViewMapOff,
    canViewOpV3,
    canViewOPV3ADS,
    canManageAssetDataStore,
    canManageExternalLinks,
    canViewExternalLinks,
    canManageRiskIntelligenceDivisionSync,
    canViewDivisionBoundaries,
    canViewBillingUsage,
    canViewPeopleOverTime,
    canManageIpaws,
    canInitiateIpaws,
    canViewPredefinedLocations,
    canViewIntegration,
    isCRCOrg
};
